export const needsInitialFetch = (fetchingProgramInfo, programInfo) =>
  !fetchingProgramInfo && !programInfo?.option_details?.length;

export const hasOptionOperationCompleted = (
  addingOption,
  addedOption,
  updatingOption,
  updatedOption,
  updatingOptionStatus,
  updatedOptionStatus,
) =>
  (!addingOption && addedOption) ||
  (!updatingOption && updatedOption) ||
  (!updatingOptionStatus && updatedOptionStatus);

export const createOptionDeletePayload = (companyId, programInfo, optionId) => ({
  company_id: companyId,
  question_id: programInfo?.questions_details?.[0]?.question_id,
  option_id: optionId,
  status: 0,
});

export const getModalTitle = editingPolicy =>
  editingPolicy ? 'Edit Policy' : 'Add Policy';

export const getOptionsLength = programInfo =>
  programInfo?.option_details?.length || 0;

export const getAllSlotsFromProgramInfo = programInfo => {
  const allSlots = [];
  if (!programInfo?.option_details) return allSlots;

  programInfo?.option_details?.forEach(option => {
    const restrictionDetails = option?.restriction_details;
    if (restrictionDetails?.day_res) {
      restrictionDetails?.day_res?.forEach(dayRes => {
        if (dayRes?.slot_res) {
          dayRes?.slot_res?.forEach(slot => {
            allSlots.push({
              startTime: slot?.start_time || '00:00',
              endTime: slot?.end_time || '23:59',
            });
          });
        }
      });
    }
  });

  return allSlots;
};
